export default __webpack_public_path__ + "static/media/Mockup_black.4c043a6a.jpg";